export const viewTitle = "График передачи дел";
export const viewUniqKey = "handover";
